import * as React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import { useViewportState } from '../../../../commonv3/hooks/useViewportState';
import { BannerDescription, BannerImage } from '../../molecules/multi_creator/MultiCreatorBanner';
import './completeApplyMultiCreatorBanner.module.scss';
import BannerSp from '../../molecules/multi_creator/images/banner-mc-sp.png';
import BannerPc from '../../molecules/multi_creator/images/banner-mc-pc.png';
import { Link } from 'react-router-dom';
import { V3Routes } from '../../../routes';

export const CompleteApplySectionMultiCreatorBanner = () => (
    <div styleName="complete_apply_multicreator">
        <div styleName="multicreator_title">MULTI CREATOR COURSE Designerへ入会希望の方へ</div>
        <CompleteApplyMultiCreatorBanner />
    </div>
);

export const CompleteApplyMultiCreatorBanner = observer(({ className = null, background = 'gray' }) => {
    const { isSp } = useViewportState();
    const header = '';
    const description = (
        <div styleName="description">
            MULTI CREATOR COURSE Designerは、<br />
            未経験でクリエイターへのキャリアチェンジを目指す女性のための<span styleName="red">
                短期集中型の特別コース
            </span>です。
        </div>
    );
    return isSp ? (
        <CompleteApplyMultiCreatorBannerSp header={header} description={description} />
    ) : (
        <CompleteApplyMultiCreatorBannerPc
            className={className}
            background={background}
            header={header}
            description={description}
        />
    );
});

export const CompleteApplyMultiCreatorBannerSp = ({ header, description }) => {
    return (
        <div styleName="multi-creator-banner-wrapper">
            <div styleName="multi-creator-banner-content">
                <div styleName="content">
                    <BannerImage image={BannerSp} />
                    <BannerDescription header={header}>{description}</BannerDescription>
                    <MultiCreatorApplyLink />
                </div>
            </div>
        </div>
    );
};

export const CompleteApplyMultiCreatorBannerPc = ({ className = '', background, header, description }) => {
    return (
        <div styleName={classNames('multi-creator-banner-wrapper', background)} className={className}>
            <div styleName="multi-creator-banner-content">
                <BannerImage image={BannerPc} />
                <div styleName="content">
                    <BannerDescription header={header}>{description}</BannerDescription>
                    <MultiCreatorApplyLink />
                </div>
            </div>
        </div>
    );
};

export const MultiCreatorApplyLink = () => {
    // TODO: マルシーコースの申し込みページができたら修正
    const page_key = 'multicreator';
    return (
        <Link
            id="multicreator_apply_link"
            styleName="apply_button"
            to={V3Routes.applicationPageSignIn(page_key)}
            target="_blank"
        >
            <div styleName="multicreator_apply_button-text">
                MULTI CREATOR COURSE<br />入会に進む
            </div>
            <div styleName="arrow" />
        </Link>
    );
};
